import WorkerAnalyticService from "@/services/worker-analytic";

export async function getAnalytics() {
  const {data} = await WorkerAnalyticService.get();
  return data.data;
}